import { getAdminAreaByIdApi } from "@/api/adminArea/adminAreaApi";
import { optimizeSelectValue } from "@/api/configuration/useConfigurationAPI";
import { AnalysisConfigurationDetail } from "@/types/project";

export const enhanceWithAdminAreaData = async (
  config: AnalysisConfigurationDetail
): Promise<AnalysisConfigurationDetail> => {
  const adminAreaId = config.area_input?.adm_area_id;

  if (!adminAreaId) return config;

  try {
    const adminAreaData = await getAdminAreaByIdApi(adminAreaId);
    return {
      ...config,
      adminAreaData: {
        selectValue: optimizeSelectValue(adminAreaData),
        geoData: {
          data: [adminAreaData]
        }
      }
    };
  } catch (error) {
    console.error("Failed to fetch administrative area data:", error);
    return config;
  }
};
